import React, { useCallback, useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import { AppRemixIcon } from "@/layout/AppComponents";
import Translator from "../../../../components/helpers/Translator";
import AppLink from "../../../../../routing/helpers/AppLink";
import { axiosPath } from "../../../../../routing/helpers/router";
import * as currentPageAction from "../../../../../store/actions/currentPageAction";
import ErrorHandler from "../../../../components/error/ErrorHandler";

export default function CommunicationPipelineUserNavbar() {
  const { moduleBridgeHex, reportHex } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPage = useSelector((state) => state.currentPage);
  const [userType] = useState("user");

  const loadCommunicationAlerts = useCallback(async () => {
    axios
      .post(
        axiosPath(
          "api_r_user_module_communicationPipeline_report_communication_alerts"
        ),
        {
          moduleBridgeHex,
          reportHex,
          type: userType,
        }
      )
      .then((r) => {
        dispatch(
          currentPageAction.change(
            "unseenCommunications",
            r?.data?.unseenCommunications,
            true
          )
        );
      })
      .catch((e) => dispatch(ErrorHandler(e)));
  }, [moduleBridgeHex, reportHex, userType]);

  useEffect(() => {
    if (!location?.pathname?.includes("/communication/")) {
      loadCommunicationAlerts();
    }
  }, []);

  return (
    <div className="mb-2">
      <AppLink
        as="a"
        className={`btn btn-xs btn-${
          location?.pathname?.includes("/status/") ? "" : "outline-"
        }light mr-3`}
        path="user_module_communicationPipeline_user_report_status"
        params={{ moduleBridgeHex, reportHex }}
      >
        <Translator file="module-communicationPipeline" name="status" />
      </AppLink>
      <AppLink
        as="a"
        className={`d-inline-flex mr-3 btn btn-xs btn-${
          currentPage?.unseenCommunications > 0
            ? "warning"
            : location?.pathname?.includes("/thread/")
            ? "light"
            : "outline-light"
        } `}
        path="user_module_communicationPipeline_user_report_thread"
        params={{ moduleBridgeHex, reportHex }}
      >
        <span
          title={
            currentPage?.unseenCommunications > 0
              ? `${ReactDOMServer.renderToString(
                  <Translator
                    file="module-communicationPipeline"
                    name="you-have"
                  />
                )} ${currentPage?.unseenCommunications} ${
                  currentPage?.unseenCommunications === 1
                    ? ReactDOMServer.renderToString(
                        <Translator
                          file="module-communicationPipeline"
                          name="notification"
                        />
                      )
                    : ReactDOMServer.renderToString(
                        <Translator
                          file="module-communicationPipeline"
                          name="notifications"
                        />
                      )
                } ${ReactDOMServer.renderToString(
                  <Translator
                    file="module-communicationPipeline"
                    name="unread"
                  />
                )}`
              : ""
          }
        >
          <Translator
            file="module-communicationPipeline"
            name="communication-threads"
          />
        </span>
        {currentPage?.unseenCommunications > 0 && (
          <span className="ml-2">
            <AppRemixIcon icon="notification" />
          </span>
        )}
      </AppLink>
    </div>
  );
}
